import React from 'react';
import PublicAppointmentBooking from '@/components/public/PublicAppointmentBooking';

const PublicAppointment: React.FC = () => {
  return <PublicAppointmentBooking />;
};

export default PublicAppointment;
